module.exports = __webpack_public_path__ + "img/file.ca38737c.svg";